import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(amount || 0);
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function calculateVariance(estimated, actual) {
  if (!estimated || estimated === 0) return null;
  return ((actual - estimated) / estimated) * 100;
}

export function getStatusColor(status) {
  switch (status) {
    case 'pending':
      return 'bg-red-100 text-red-700 border-red-200';
    case 'partial':
    case 'documents_uploaded':
      return 'bg-amber-100 text-amber-700 border-amber-200';
    case 'cleared':
      return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    default:
      return 'bg-slate-100 text-slate-700 border-slate-200';
  }
}

export function getStatusLabel(status) {
  switch (status) {
    case 'pending':
      return 'Pending';
    case 'partial':
      return 'Partial';
    case 'documents_uploaded':
      return 'Docs Uploaded';
    case 'cleared':
      return 'Cleared';
    default:
      return status;
  }
}

export function getTransportIcon(type) {
  switch (type?.toLowerCase()) {
    case 'sea':
      return 'Ship';
    case 'air':
      return 'Plane';
    case 'road':
      return 'Truck';
    default:
      return 'Package';
  }
}
